import { render, staticRenderFns } from "./RedactorAdminDashboard.vue?vue&type=template&id=4faf5fa2&scoped=true&"
import script from "./RedactorAdminDashboard.vue?vue&type=script&lang=js&"
export * from "./RedactorAdminDashboard.vue?vue&type=script&lang=js&"
import style0 from "./RedactorAdminDashboard.vue?vue&type=style&index=0&id=4faf5fa2&prod&lang=css&"
import style1 from "./RedactorAdminDashboard.vue?vue&type=style&index=1&id=4faf5fa2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4faf5fa2",
  null
  
)

export default component.exports